// extracted by mini-css-extract-plugin
module.exports = {"secondAnswer":"styles_secondAnswer__c_0o-","images":"styles_images__1H_KX"};